import React, { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Sidebar from 'components/App/DesktopView/Layout/Sidebar'
import PresenceButton from 'components/Presence/Button'
import {
  selectPresence,
  selectAutoAwaySetting,
  selectAutoOfflineSetting,
  selectAutoPresenceSetting,
} from 'ducks/chat/selectors/presence'
import {
  doUpdatePresence,
  doUpdatePresenceSettings,
} from 'ducks/chat/actions/presence'
import Folders from '../Folders'
import withMatrixClient from '../withMatrixClient'

function ChatSideBar({ isMatrixReady, environment }) {
  const presence = useSelector(selectPresence)
  const autoAwaySetting = useSelector(selectAutoAwaySetting)
  const autoOfflineSetting = useSelector(selectAutoOfflineSetting)
  const autoPresenceSetting = useSelector(selectAutoPresenceSetting)
  const dispatch = useDispatch()

  const handlePresenceChange = useCallback(
    async newPresence => {
      if (isMatrixReady && environment) {
        const autoPresence = newPresence === 'autoPresence'
        const derivedPresence = autoPresence ? 'online' : newPresence
        await environment.presence.setAutoPresence(autoPresence)
        await environment.presence.setState(derivedPresence)
        dispatch(doUpdatePresence(derivedPresence))
        dispatch(doUpdatePresenceSettings({ autoPresence }))
      }
    },
    [isMatrixReady, environment, dispatch]
  )

  const handlePresenceSettingChange = useCallback(
    ({
      autoAwaySetting: newAutoAwaySetting,
      autoOfflineSetting: newAutoOfflineSetting,
    }) => {
      if (isMatrixReady && environment) {
        environment.presence.setAutoAway(newAutoAwaySetting)
        environment.presence.setAutoOffline(newAutoOfflineSetting)
        dispatch(
          doUpdatePresenceSettings({
            autoAway: newAutoAwaySetting,
            autoOffline: newAutoOfflineSetting,
          })
        )
      }
    },
    [isMatrixReady, environment, dispatch]
  )

  return (
    <Sidebar
      flexible
      title="Chat"
      footer={
        isMatrixReady && (
          <PresenceButton
            presence={presence}
            autoPresence={autoPresenceSetting}
            onSettingChange={handlePresenceSettingChange}
            onPresenceChange={handlePresenceChange}
            autoAwaySetting={autoAwaySetting}
            autoOfflineSetting={autoOfflineSetting}
            autoPresenceSetting={autoPresenceSetting}
          />
        )
      }
    >
      <Folders type="widget" />
    </Sidebar>
  )
}

export default withMatrixClient(ChatSideBar)
